<template>
	<div class="main" v-title data-title="零部件下载记录">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">下载记录</h1>
					</div>
				</div>
				<div class="formW">
					<el-table :data="tableData" border style="width: 100%">
						<el-table-column prop="title" label="产品名" width="250">
						</el-table-column>
						<el-table-column prop="product_model" label="型号" width="260">
						</el-table-column>
						<el-table-column prop="company" label="供应商/品牌" width="128">
						</el-table-column>
						<el-table-column prop="trade_sn" label="询价单号" width="140">
						</el-table-column>
						<el-table-column prop="creattime" label="下载日期" width="200">
						</el-table-column>
					</el-table>
					<div class="block pdb10 mt40" style="float: right">
						<el-pagination @current-change="handleCurrentChange"@size-change="handSizeChange" :current-page.sync="page" :page-sizes="[10, 20, 30, 40]"
						 :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				total: 1,
				pcount: '10', //每页多少条
				page: 1, //当前页码数
				titleDec: "",
				tableData: []

			};
		},
		created() {
			this.handownlist();
		},
		methods: {
			//点击第几页
			handleCurrentChange(val) {
				this.page = val;
				this.handownlist();
			},
			handSizeChange(val){
				this.pcount=val;
				this.handownlist()
			},
			handownlist(){
				this.$postcn('partshome/downlist', {
					p:this.page,
					pcount:this.pcount
				}, this).then((res) => {
					if (res.status == 200&&res.data.code!=-4004) {
						// console.log(res)
						this.tableData = res.data.data.list
						this.total = res.data.data.count
					}else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else{
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				})
			}
		}
	}
</script>

<style style="scoped">
	.item1 {
		display: inline-block;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.formW {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.inputW {
		width: 200PX;
	}

	/*  .el-input--mini .el-input__inner {
    line-height: 38PX !important;
    height: 38PX !important;
    padding-left: 10PX;
    width: 150PX;
  } */

	/* .itemPD .el-form-item {
		margin-bottom: 22px;
		width: 353px;
		display: inline-block;
	} */
</style>



// WEBPACK FOOTER //
// src/pages/people/download.vue